const li = [{
        color: '',
        index: 1,
    },
    {
        color: '',
        index: 2,
    },
    {
        color: '',
        index: 3,
    },
    {
        color: '',
        index: 4,
    },
    {
        color: '',
        index: 5,
    },
    {
        color: '',
        index: 6,
    },
    {
        color: '',
        index: 7,
    },
    {
        color: '',
        index: 8,
    },
    {
        color: '',
        index: 9,
    },
    {
        color: '',
        index: 10,
    },
    {
        color: '',
        index: 11,
    },
    {
        color: '',
        index: 12,
    },

];
export default li;